/**
 * Checkbox component type definitions
 */

export enum CheckboxSize {
  Small = 'sm',
  Default = 'default',
  Large = 'lg',
}

export enum CheckboxVariant {
  Default = 'default',
  Destructive = 'destructive',
}
